// extracted by css-extract-rspack-plugin
export default {"empty":"empty-um4ATK","title":"title-IUExTd"};